module.exports = __webpack_public_path__ + "img/service4.5af2b058.png";